module.exports = __webpack_public_path__ + "assets/1eb22e79.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/play-button-yellow.png
// module id = 102
// module chunks = 0